module.exports = __webpack_public_path__ + "static/media/1.23f491f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/cats/1.jpg
// module id = 206
// module chunks = 0